<template>
  <FormItem
    :label="label"
    :prop="prop"
  >
    <DatePicker
      v-model="val"
      type="date"
      size="large"
      format="yyyy年MM月dd日"
      :placeholder="placeholder"
      :disabled="disabled"
      :readonly="readonly"
      :options="options"
      @on-change="handleChange($event, 'date')"
    />
    <span 
      v-if="tips"
      class="fz-tiny"
      :style=" {marginLeft: '10px'}"
    >{{ tips }}
    </span>
  </FormItem>
</template>

<script>
  import { DatePicker, FormItem } from 'iview';
  import format from 'date-fns/format';

  export default {
    components: { DatePicker, FormItem },
    props: {
      label: {
        type: String,
        default: ''
      },
      prop: {
        type: String,
        default: ''
      },
      placeholder: {
        type: String,
        default: ''
      },
      disabled: {
        type: Boolean,
        default: false
      },
      readonly: {
        type: Boolean,
        default: false
      },
      tips: {
        type: String,
        default: null
      },
      value: {
        type: [Date, String],
        default: ''
      },
      options: {
        type: Object,
        default: () => ({
          disabledDate(date) {
            return date && date.valueOf() < Date.now() - 86400000;
          }
        })
      },
    },
    computed: {
      val: {
        get() {
          return format(this.value, 'YYYY-MM-DD');
        },
        set(val) {
          return this.$emit('input', format(val, 'YYYY-MM-DD'));
        }
      }
    },
    methods: {
      handleChange(val, key) {
        if (key === 'date') {
          val = val.replace(/(\d{4}).(\d{2}).(\d{2}).$/, '$1-$2-$3');
        }
        this.$emit('input', val);
      }
    }
  };
</script>